import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export default function TravelSearch() {
  const nav = useNavigate();
  const [lang, setLang] = useState<"en"|"ar">("en");
  const [origin, setOrigin] = useState("DXB");
  const [destination, setDestination] = useState("LHR");
  const [depart, setDepart] = useState("");
  const [ret, setRet] = useState("");
  const [adults, setAdults] = useState(2);
  const [loading, setLoading] = useState(false);
  const t = (en:string, ar:string)=> lang==="en"?en:ar;

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);

    const slices = [
      { origin, destination, departure_date: depart }
    ];
    if (ret) slices.push({ origin: destination, destination: origin, departure_date: ret });

    // Duffel Offer Requests payload
    const payload = {
      slices,
      passengers: Array.from({length: adults}).map(()=>({ type: "adult" })),
      cabin_class: "economy",
      max_connections: 1,
      return_offers: true,
      currency: "AED",
    };

    try {
      const { data, error } = await supabase.functions.invoke('search', {
        body: payload
      });
      
      setLoading(false);

      if (error) {
        console.error('Search error:', error);
        alert(t("Search failed. Please try again.", "فشل البحث. يرجى المحاولة مرة أخرى."));
        return;
      }

      if (data?.data?.offers) {
        nav("/travel/results", { 
          state: { 
            offers: data.data.offers, 
            search: { origin, destination, depart, ret, adults } 
          } 
        });
      } else {
        alert(t("No offers found. Try different dates.", "لا توجد عروض. جرّب تواريخ أخرى."));
      }
    } catch (error) {
      setLoading(false);
      console.error('Search error:', error);
      alert(t("Search failed. Please try again.", "فشل البحث. يرجى المحاولة مرة أخرى."));
    }
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-5xl mx-auto p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-heading font-semibold text-flexaura-navy">
            {t("Flexaura Travel", "فليكساورا للسفر")}
          </h1>
          <div className="flex gap-2">
            <button 
              onClick={()=>setLang("en")} 
              className={`px-3 py-1 rounded-xl border smooth-transition ${
                lang==="en"
                  ? "bg-primary text-primary-foreground border-primary" 
                  : "bg-background text-foreground border-border hover:bg-muted"
              }`}
            >
              EN
            </button>
            <button 
              onClick={()=>setLang("ar")} 
              className={`px-3 py-1 rounded-xl border smooth-transition ${
                lang==="ar"
                  ? "bg-primary text-primary-foreground border-primary" 
                  : "bg-background text-foreground border-border hover:bg-muted"
              }`}
            >
              AR
            </button>
          </div>
        </div>

        <form onSubmit={onSubmit} className="bg-card border rounded-2xl p-5 card-shadow">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <input 
              value={origin} 
              onChange={e=>setOrigin(e.target.value.toUpperCase())}
              placeholder={t("Origin (IATA)", "المغادرة (IATA)")}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
            />
            <input 
              value={destination} 
              onChange={e=>setDestination(e.target.value.toUpperCase())}
              placeholder={t("Destination (IATA)", "الوصول (IATA)")}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
            />
            <input 
              type="date" 
              value={depart} 
              onChange={e=>setDepart(e.target.value)}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
            />
            <input 
              type="date" 
              value={ret} 
              onChange={e=>setRet(e.target.value)}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
            />
            <input 
              type="number" 
              min={1} 
              value={adults} 
              onChange={e=>setAdults(parseInt(e.target.value||"1"))}
              className="rounded-2xl border border-input bg-background px-3 py-3 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 smooth-transition" 
              placeholder={t("Adults", "بالغون")} 
            />
          </div>
          <div className="mt-4">
            <button 
              disabled={loading}
              className="px-6 py-3 rounded-2xl font-medium text-white gradient-bg hover:opacity-90 smooth-transition disabled:opacity-50"
            >
              {loading ? t("Searching...", "جارٍ البحث...") : t("Search Flights", "ابحث عن رحلات")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}